import type { SuperAdminCompletedRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import {
  inlineAssigneeCell,
  inlineBrandCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";
import { renderRating } from "../../helpers/renderHelpers";

// Completed Tab Configuration for SuperAdmin
// Columns: Name, Account, Brand, Assignee, Created by, Completed date, Rating, Request/Design type
export const completedTableConfig: TableConfig<SuperAdminCompletedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell, // Inline editable
      header: "Brand",
      key: "brand",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.brand || 160,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell, // Inline editable
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.assignee,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.createdBy,
    },
    {
      accessor: "completedDate",
      cellRenderer: dateCell,
      header: "Completed date",
      key: "completedDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.completedDate,
    },
    {
      accessor: "status",
      cellRenderer: statusCell,
      header: "Status",
      key: "status",
      sortable: false,
      width: 150,
    },
    {
      accessor: "rating",
      cellRenderer: (value: unknown) =>
        renderRating(value as null | number | undefined),
      header: "Rating",
      key: "rating",
      sortable: true, // Rating sorting now supported with null-safe backend logic
      width: TABLE_LAYOUT_PRESETS.superadmin.rating,
    },
    {
      accessor: "designType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
  ],
  defaultSort: {
    column: "completedDate",
    direction: "desc", // Most recently completed at the top
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "superadmin-completed-requests",
  title: "Completed",
};
